import { jsx as e, jsxs as x } from "react/jsx-runtime";
import { aV as g, w as j } from "../../vendor-Dd6qj6gJ.js";
import { useRef as w } from "react";
import { layer as L } from "../../theme/layer.js";
import "../../theme/spacing.js";
import { omitStyleRenderProps as P } from "../../utils/omitStyleRenderProps/index.js";
import { FieldDescription as C } from "../FieldDescription/index.js";
import { FieldError as N } from "../FieldError/index.js";
import { SelectFieldLabel as R } from "./SelectFieldLabel/index.js";
import { Surface as V } from "../Surface/index.js";
import { SelectFieldValueProvider as z } from "./SelectFieldContext/index.js";
import { SelectValue as A } from "./SelectValue/index.js";
import { SelectMenuContent as M } from "./SelectFieldContent/index.js";
import { SelectListBox as B } from "./SelectListBox/index.js";
import '../../assets/index53.css';const D = "_selectField_oasyj_1", E = "_popover_oasyj_41", I = "_surface_oasyj_48", t = {
  selectField: D,
  popover: E,
  surface: I
};
function ee({
  label: r,
  errorMessage: d,
  description: n,
  items: l,
  onLoadMore: m,
  placeholder: f,
  search: a,
  "aria-label": i,
  isLoading: p = !1,
  hasMore: h = !0,
  isVirtualized: u = !1,
  fullWidth: v = !1,
  matchTriggerWidth: S = !1,
  startIcon: F,
  horizontal: _ = !1,
  ...o
}) {
  const c = w(null), s = (r ?? i ?? "options").toString().toLocaleLowerCase(), b = f ?? `Choose ${s}`, y = a?.placeholder ?? `Search ${s}`, $ = Array.isArray(o.value) ? o.value.length > 0 : !!o.value;
  return /* @__PURE__ */ e(
    g,
    {
      ...P(o),
      "aria-label": r ? void 0 : i,
      "data-component": "SelectField",
      "data-selection-mode": o.selectionMode,
      "data-has-selection": $ || void 0,
      "data-fullwidth": v || void 0,
      "data-horizontal": _ || void 0,
      className: t.selectField,
      children: /* @__PURE__ */ x(z, { items: l, children: [
        /* @__PURE__ */ e(R, { children: r }),
        /* @__PURE__ */ e(A, { ref: c, placeholder: b, startIcon: F }),
        /* @__PURE__ */ e(C, { children: n }),
        /* @__PURE__ */ e(N, { children: d }),
        /* @__PURE__ */ e(
          j,
          {
            className: t.popover,
            style: { zIndex: L("menu") },
            triggerRef: c,
            children: /* @__PURE__ */ e(
              V,
              {
                className: t.surface,
                "data-match-trigger-width": S || void 0,
                children: /* @__PURE__ */ e(M, { search: a, searchPlaceholder: y, children: /* @__PURE__ */ e(
                  B,
                  {
                    items: l,
                    isLoading: p,
                    onLoadMore: m,
                    hasMore: h,
                    isVirtualized: u
                  }
                ) })
              }
            )
          }
        )
      ] })
    }
  );
}
export {
  ee as SelectField
};
